<template>
  <svg
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 6.05263C13 6.05263 11.8392 4.47107 10.8962 3.5274C9.95318 2.58373 8.65002 2 7.21053 2C4.33283 2 2 4.33283 2 7.21053C2 10.0882 4.33283 12.4211 7.21053 12.4211C9.586 12.4211 11.5902 10.8314 12.2174 8.65789M13 6.05263V2.57895M13 6.05263H9.52632"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
